<template>
<div class="background-pattern-container">
  <div class="container">
  <slot></slot>
  </div>
 </div>
</template>

<script>
export default {
  name: 'backgroundPattern',
}
</script>

<style lang="scss" scoped>
.background-pattern-container{
  background: url(../../../assets/cases/mobilyze/Folded_Paper_Werk_Mobilyze_image_5.jpg);
  min-height:400px;

  h3,p{
    color:$white;
    opacity:1;
  }
  .odd-even-grid{
    padding-top: layout-val-64(2.5);
    padding-left: layout-val-8(4);
    padding-right: layout-val-8(4);
  }
}
.odd-even-grid{
  display: flex;
  margin-top: layout-val-64(2);
    .img-box, .text-box{
      flex:1;

      img{
        max-width: 560px;
        width: 100%;
        max-height: 350px;
        border-radius: 15px;
      }

      .float-right{
        float:right;
      }
    }
    .text-box{
      position: relative;
      .content{
         @include pos-center($axis: 'y');
      }
    }
}
.last-item{
  padding-bottom: layout-val-64(2);
}

.padding-left{
  padding-left: layout-val-8(2);
}

.padding-right{
  padding-right: layout-val-8(2);
}


@media screen and (max-width: 640px) {
  .odd-even-grid{
    flex-direction: column;
    margin-top:layout-val-8(8);
  }
 
  .odd-even-grid .text-box .content{
    position: relative;
    top:0;
    transform: none;
  }

  .odd{
    flex-direction: column-reverse;
  }

  .background-pattern-container .odd-even-grid{
    padding-top:60px;
  }

}
</style>